import React from "react";

const StatSlide = {
  id: "stat-slide",
  name: "Stat Highlights",
  fields: [
    {
      id: "title",
      label: "Title",
      type: "text",
      defaultValue: "",
    },
    {
      id: "subtitle",
      label: "Subtitle",
      type: "text",
      defaultValue: "",
    },
    {
      id: "stats",
      label: "Stats (JSON array of { label, value, trend, icon, description })",
      type: "text",
      defaultValue: "[]",
    },
    {
      id: "bgColor",
      label: "Background Color",
      type: "text",
      defaultValue: "linear-gradient(135deg, #064e3b 0%, #065f46 100%)",
    },
  ],
  render: (content) => {
    const {
      title = "",
      subtitle = "",
      bgColor = "linear-gradient(135deg, #064e3b 0%, #065f46 100%)",
    } = content;

    let parsedStats = [];
    try {
      if (typeof content.stats === "string") {
        const parsed = JSON.parse(content.stats);
        if (Array.isArray(parsed)) {
          parsedStats = parsed;
        }
      } else if (Array.isArray(content.stats)) {
        parsedStats = content.stats;
      }
    } catch (error) {
      console.warn("Error parsing stats:", error);
    }

    return (
      <div
        className="w-full h-full relative overflow-hidden text-white"
        style={{ background: bgColor }}
      >
        {/* Background Pattern */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 opacity-10">
            <div className="grid grid-cols-8 grid-rows-8">
              {[...Array(64)].map((_, i) => (
                <div
                  key={i}
                  className="w-full h-full border-r border-t border-white/5"
                  style={{
                    transform: `rotate(${Math.random() * 360}deg)`,
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Main Content Container */}
        <div className="relative z-10 flex flex-col h-full p-8">
          {/* Header Section */}
          <div className="text-center mb-8">
            <h2 className="text-4xl font-black relative">
              <span className="relative text-emerald-200">{title}</span>
            </h2>
            <p className="text-lg text-emerald-100/90">{subtitle}</p>
            <div className="w-32 h-1 mx-auto mt-2 bg-gradient-to-r from-transparent via-emerald-300/30 to-transparent" />
          </div>

          {/* Stats Grid */}
          <div className="flex-1 grid grid-cols-2 gap-6 mb-6">
            {parsedStats.map((stat, idx) => (
              <div
                key={idx}
                className="group relative bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10
                          transform transition-all duration-300 hover:bg-white/10"
              >
                {/* Stat Header */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <span className="text-3xl">{stat.icon}</span>
                    <h3 className="text-xl font-bold text-emerald-100">
                      {stat.label}
                    </h3>
                  </div>
                  <div
                    className={`px-3 py-1 rounded-full text-sm font-medium
                                ${
                                  stat.trend?.startsWith("+")
                                    ? "bg-emerald-900/50 text-emerald-200"
                                    : "bg-red-900/50 text-red-200"
                                }`}
                  >
                    {stat.trend}
                  </div>
                </div>

                {/* Stat Value */}
                <div className="mb-3">
                  <span className="text-4xl font-black relative text-emerald-200">
                    {stat.value}
                  </span>
                </div>

                {/* Description */}
                <p className="text-sm text-emerald-100/70">
                  {stat.description}
                </p>

                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-16 h-16">
                  <div className="absolute top-0 right-0 w-full h-0.5 bg-gradient-to-l from-emerald-300/30" />
                  <div className="absolute top-0 right-0 w-0.5 h-full bg-gradient-to-b from-emerald-300/30" />
                </div>
              </div>
            ))}
          </div>

          {/* Bottom Decoration */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            <div className="w-2 h-2 rounded-full bg-emerald-400/60" />
            <div className="w-2 h-2 rounded-full bg-emerald-400/40" />
            <div className="w-2 h-2 rounded-full bg-emerald-400/20" />
          </div>
        </div>
      </div>
    );
  },
};

export default StatSlide;
